import { gql } from '@apollo/client';
import { FileFragment } from 'graphql/File/fragments/FileFragment';
/**
 * @const ExportSaleItemsMutation
 * @since 1.0.0
 */
export const ExportSaleItemsMutation = gql `
  mutation ExportSaleItemsMutation($input: ExportSaleItemsInput!) {
    exportSaleItems(input: $input) {
      ...FileFragment
    }
  }

  ${FileFragment}
`;
